import { Row } from 'antd';
import { ICalendarSchema } from 'features/appointment/services/types/calendar';
import { memo, useMemo } from 'react';
import CalendarStyled, { fixedStyle } from './styles';
import HeaderItem from './HeaderItem';
import appointmentSelectors from 'features/appointment/services/selectors';

type Props = {
  schema: ICalendarSchema;
};
const CalendarViewHeader = ({ schema }: Props) => {
  const typeView = appointmentSelectors.getViewType();
  return (
    <CalendarStyled.THead>
      <CalendarStyled.TRow>
        <CalendarStyled.TH fixedHigh className='fixedHigh' style={fixedStyle}>
          <Row className='actions' justify={'space-between'} />
        </CalendarStyled.TH>
        {schema.headers.length > 0 ? (
          schema.headers.map((item) => {
            return (
              <CalendarStyled.TH key={item.id} fixed style={item.color ? { background: item.color } : undefined}>
                <HeaderItem key={item.id} typeView={typeView} item={item} />
              </CalendarStyled.TH>
            );
          })
        ) : (
          <CalendarStyled.TH fixed />
        )}
      </CalendarStyled.TRow>
    </CalendarStyled.THead>
  );
};

export default memo(CalendarViewHeader);
